import { FaEdit, FaPlus } from "react-icons/fa";
import { SecondaryButton } from "../../../UI/DesignStandards";

const PrizeFundHeader = ({
  totalPrizeFund,
  isRefreshing,
  isPayoutFinalized,
  canManage,
  showAddForm,
  prizeFunds,
  onAddPrizeFund,
  onEditPrizeFunds,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
      <div className="text-center sm:text-left">
        <h2 className="heading-display text-xl">
          Added money
        </h2>
        <p className="text-sm font-medium text-brand-charcoal mt-1">
          Added money is a board total, not a per-bowler rate.
        </p>
        <div className="mt-2 flex flex-wrap gap-4 text-sm text-brand-muted">
          <span className="flex items-center gap-1">
            <span className="font-medium">Total:</span>
            <span className="font-score font-semibold text-brand-charcoal">
              ${totalPrizeFund.toFixed(2)}
            </span>
            {isRefreshing && (
              <div className="inline-flex items-center ml-2">
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-brand-gold-ink"></div>
              </div>
            )}
          </span>
        </div>
        {isPayoutFinalized && (
          <div className="mt-3 card-inset p-3">
            <p className="text-sm text-brand-muted">
              Payouts have been locked. Additional prize funds cannot be
              modified.
            </p>
          </div>
        )}
      </div>

      <div className="flex flex-wrap gap-2 justify-center sm:justify-end">
        {canManage && !showAddForm && (
          <SecondaryButton
            onClick={onAddPrizeFund}
            disabled={isPayoutFinalized}
            className={
              isPayoutFinalized
                ? "opacity-50 cursor-not-allowed !px-3 !py-2 text-sm"
                : "!px-3 !py-2 text-sm"
            }
            title={
              isPayoutFinalized
                ? "Payouts have been locked and cannot be changed"
                : "Add a new prize fund"
            }
          >
            <FaPlus className="mr-2" />
            Add Prize Fund
          </SecondaryButton>
        )}

        {canManage && prizeFunds.length > 0 && (
          <SecondaryButton
            onClick={onEditPrizeFunds}
            disabled={isPayoutFinalized}
            className={
              isPayoutFinalized
                ? "opacity-50 cursor-not-allowed !px-3 !py-2 text-sm"
                : "!px-3 !py-2 text-sm"
            }
            title={
              isPayoutFinalized
                ? "Payouts have been locked and cannot be changed"
                : "Edit existing prize funds"
            }
          >
            <FaEdit className="mr-2" />
            Edit Prize Funds
          </SecondaryButton>
        )}
      </div>
    </div>
  );
};

export default PrizeFundHeader;
